// Minha Conta V2 (ENG-362): com o flag ligado, navegações pra /user/*
// não trocam de página — abrem a tela correspondente dentro do modal
// global (UserV2Modal no layout default). Fechar o modal mantém o usuário
// onde estava. Deep link direto vai pra home com o modal aberto.
export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) {
    return;
  }

  const { isUserV2Enabled } = useFeatureFlagsJson();

  if (!isUserV2Enabled.value) {
    return;
  }

  const { openByPath, syncAddressBar } = useUserV2Modal();

  if (!openByPath(to.fullPath)) {
    return;
  }

  const isInitialLoad = to.fullPath === from.fullPath;

  if (isInitialLoad) {
    // navigateTo faz uma navegação de verdade pra home (senão a página
    // física por trás do link renderiza sem o menu/shell do painel) — e
    // essa navegação chama seu próprio history.replaceState('/'), apagando
    // o link original. afterEach roda depois que esse replaceState já
    // aconteceu; usa esse momento pra devolver a URL pro link acessado.
    const router = useRouter();
    const deepLinkPath = to.fullPath;
    const restoreDeepLink = router.afterEach(() => {
      restoreDeepLink();
      syncAddressBar(deepLinkPath);
    });

    return navigateTo(localeLink('/'), { replace: true });
  }

  // navegação interna: mantém a página atual, só troca a tela do modal.
  // openByPath já sincronizou a barra de endereço com o caminho canônico da
  // tela (ver useUserV2Modal), mas sem query string — substitui aqui pelo
  // fullPath de verdade (ex.: ?section=deposit) antes de abortar.
  syncAddressBar(to.fullPath);

  return abortNavigation();
});
